
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function ServicesDetail() {
  const services = [
    {
      id: 1,
      title: 'リノベーション',
      subtitle: 'Renovation',
      description: '建物に新しい価値と機能を付加し、お客様のニーズに合わせた理想的な空間を創造します。単なる改修ではなく、建物の潜在能力を最大限に引き出し、現代のライフスタイルやビジネスニーズに適応させます。',
      features: [
        '企画・コンセプト提案',
        '現状分析・課題整理',
        'デザイン・設計提案',
        'コスト最適化',
        '工事管理・品質管理',
        'アフターフォロー'
      ],
      benefits: [
        '資産価値の向上',
        '機能性の大幅改善',
        'エネルギー効率の向上',
        '快適性・安全性の確保'
      ],
      icon: 'ri-hammer-line',
      color: 'bg-blue-500',
      image: 'https://public.readdy.ai/ai/img_res/e6583b6d5e56fc4f8c2bd2696dce8a09.jpg'
    },
    {
      id: 2,
      title: 'FM・メンテナンス',
      subtitle: 'Facility Management & Maintenance',
      description: '建物の価値を維持し、快適で安全な環境を継続的に提供するための総合管理サービスです。予防保全から緊急対応まで、建物のライフサイクル全体をサポートし、長期的な運営コストの最適化を実現します。',
      features: [
        '定期点検・保守',
        '設備管理・運転管理',
        '緊急対応サービス',
        '修繕計画立案',
        'エネルギー管理'
      ],
      benefits: [
        '運営コストの削減',
        '設備の長寿命化',
        '快適な環境の維持',
        'リスク管理の強化'
      ],
      icon: 'ri-tools-line',
      color: 'bg-green-500',
      image: 'https://readdy.ai/api/search-image?query=Professional%20facility%20maintenance%20technician%20performing%20routine%20inspection%20of%20building%20systems%20in%20modern%20Japanese%20commercial%20building%2C%20advanced%20monitoring%20equipment%20and%20diagnostic%20tools%2C%20clean%20well-maintained%20mechanical%20room%20or%20facility%20area%2C%20professional%20service%20approach%20with%20safety%20equipment%20and%20attention%20to%20detail&width=600&height=400&seq=maintenance&orientation=landscape'
    },
    {
      id: 3,
      title: 'コンサルティング',
      subtitle: 'Consulting',
      description: '建物に関する課題を専門的に分析し、最適なソリューションを提案する戦略的アドバイザリーサービスです。省エネ・省コストから将来計画まで、建物経営の最適化をトータルでサポートします。',
      features: [
        'プロジェクト管理',
        '現状分析・診断',
        '省コスト・省エネ提案',
        'ZEH・ZEB提案',
        '長期修繕計画',
        '法令対応サポート'
      ],
      benefits: [
        '戦略的な建物経営',
        'コスト削減の実現',
        '環境性能の向上',
        'リスクの事前回避'
      ],
      icon: 'ri-lightbulb-line',
      color: 'bg-orange-500',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20consultation%20meeting%20with%20facility%20management%20experts%20reviewing%20building%20plans%20and%20energy%20efficiency%20reports%2C%20modern%20conference%20room%20with%20architects%20and%20consultants%20discussing%20renovation%20strategies%2C%20laptops%20and%20documents%20on%20table%2C%20collaborative%20planning%20atmosphere%20with%20natural%20lighting&width=600&height=400&seq=consulting&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            専門的な3つのサービス領域
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            それぞれの専門性を活かし、お客様の建物に関するあらゆる課題に対応します
          </p>
        </div>

        <div className="space-y-20">
          {services.map((service, index) => (
            <div key={service.id} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              <div className="flex-1">
                <div className="flex items-center mb-6">
                  <div className={`${service.color} text-white p-4 rounded-xl mr-4`}>
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className={`${service.icon} text-2xl`}></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-3xl font-bold text-gray-900 mb-1">
                      {service.title}
                    </h3>
                    <p className="text-gray-500 text-sm uppercase tracking-wider">
                      {service.subtitle}
                    </p>
                  </div>
                </div>
                
                <p className="text-gray-600 mb-8 leading-relaxed text-lg">
                  {service.description}
                </p>

                <div className="grid md:grid-cols-2 gap-6 mb-8">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
                      <div className="w-5 h-5 flex items-center justify-center mr-2">
                        <i className="ri-service-line text-blue-600"></i>
                      </div>
                      主なサービス内容
                    </h4>
                    <ul className="space-y-2">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-center text-gray-600">
                          <div className="w-4 h-4 flex items-center justify-center mr-3">
                            <i className="ri-check-line text-green-500"></i>
                          </div>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
                      <div className="w-5 h-5 flex items-center justify-center mr-2">
                        <i className="ri-star-line text-orange-500"></i>
                      </div>
                      期待できる効果
                    </h4>
                    <ul className="space-y-2">
                      {service.benefits.map((benefit, idx) => (
                        <li key={idx} className="flex items-center text-gray-600">
                          <div className="w-4 h-4 flex items-center justify-center mr-3">
                            <i className="ri-arrow-right-line text-blue-500"></i>
                          </div>
                          {benefit}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <Button variant="outline" asChild>
                  <Link to="/contact">
                    {service.title}について詳しく相談する
                    <div className="w-5 h-5 flex items-center justify-center ml-2">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </Link>
                </Button>
              </div>

              <div className="flex-1">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-96 object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
